import React, { PropsWithChildren } from 'react'
import { Layout } from 'antd'

// components
import FormBuilderHeader from '../components/LayoutComponents/FormBuilderHeader'
import TemplateBuilderHeader from '../components/LayoutComponents/TemplateBuilderHeader'

// utils
import { PAGE } from '../utils/enums'

const { Header } = Layout

type Props = {
	children: PropsWithChildren
	page?: PAGE
}

const FormBuilderLayout = (props: Props) => {
	const { children, page } = props
	return (
		<Layout className='layout'>
			{/* <LayoutHeader page={page} /> */}
			<Header>
				{page === PAGE.SETTINGS || page === PAGE.FORM_BUILDER || page === PAGE.FORM_PREVIEW ? (
					<FormBuilderHeader page={page} />
				) : (
					<TemplateBuilderHeader page={page} />
				)}
			</Header>
			<Layout>{children as any}</Layout>
		</Layout>
	)
}

export default FormBuilderLayout
